import angular from 'angular';
import constants from 'app/constants';
import {
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './save-finding-confirm-dialog.controller';
import template from './save-finding-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, auditId, statuses, businessRisks, technicalRisks, priorities, users, finding
  }) {
    return {
      controller,
      controllerAs: 'saveFindingConfirmDialogVM',
      locals: {
        customerId,
        auditId,
        statuses,
        businessRisks,
        technicalRisks,
        priorities,
        users,
        finding
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.saveFindingConfirmDialog', [
  alerts,
  amSharedModelService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('saveFindingConfirmDialog', dialogService)
  .name;
